import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=3242f52f"
import script from "./ReportsView.vue?vue&type=script&lang=js"
export * from "./ReportsView.vue?vue&type=script&lang=js"
import style0 from "./ReportsView.vue?vue&type=style&index=0&id=3242f52f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports